import { PaymentReportViewModel } from './../../../../common/model/payment/paymentReportResponse';
import { createDataFetchSlice } from '../../../utils/dataFetch';


export const adminReportsPaymentsSlice = createDataFetchSlice<
    PaymentReportViewModel
>({ name: 'payments' });
